import React, { useState, useEffect } from "react";
import Layout from "../Common/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const LabourOutbound = () => {
  const [doList, setDoList] = useState([]);
  const [selectedDoId, setSelectedDoId] = useState("");

  useEffect(() => {
    fetchAllDO();
  }, []);

  useEffect(() => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");

    setFormData((prev) => ({
      ...prev,
      Time: `${hh}:${mm}`,
    }));
  }, []);

  const fetchAllDO = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/all-DO", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      setDoList(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch DO list", error);
      toast.error("Failed to load Delivery Orders");
    }
  };

  const handleDoSelect = (doItem) => {
    setFormData((prev) => ({
      ...prev,
      Client: doItem.clientName || "",
      Product: doItem.commodity || "",
      cargoType: doItem.cargo_type || "",
      Quantity: doItem.quantity || "",
      Bags: doItem.bags || "",
      warehouse: doItem.warehouse || "",
      Date: doItem.date || "",
    }));

    sessionStorage.setItem("deliveryorder", JSON.stringify(doItem));

    toast.success(`DO ${doItem.doNo} selected`, {
      autoClose: 1000,
    });
  };

  const navigate = useNavigate();

  const deliveryorder = JSON.parse(sessionStorage.getItem("deliveryorder"));

  const [formData, setFormData] = useState({
    Client: "",

    cargoType: "",
    bagRange: "",

    // BULK
    bulk_loading: "",
    containerCount: "",
    bulkRate: "",
    bulkTotal: 0,

    Restacking: "",
    restackingRate: "",
    restackingTotal: 0,

    Stitching: "",
    stitchingRate: "",
    stitchingTotal: 0,

    sweeping: "",
    sweepingRate: "",
    sweepingTotal: 0,

    bagRange: "",
    bagRate: "",
    bagTotal: 0,

    Others: "",
    othersRate: "",
    othersTotal: 0,

    Product: "",
    Date: "",
    Time: "",
    Quantity: "",
    Bags: "",
    warehouse: "",
  });

  const safeNumber = (val) => (isNaN(Number(val)) ? 0 : Number(val));

  const handleChange = (e) => {
    const { id, value } = e.target;

    const updatedData = { ...formData, [id]: value };

    // Labour totals
    updatedData.restackingTotal =
      safeNumber(updatedData.Restacking) *
      safeNumber(updatedData.restackingRate);
    updatedData.stitchingTotal =
      safeNumber(updatedData.Stitching) * safeNumber(updatedData.stitchingRate);
    updatedData.sweepingTotal =
      safeNumber(updatedData.sweeping) * safeNumber(updatedData.sweepingRate);
    updatedData.othersTotal =
      safeNumber(updatedData.Others) * safeNumber(updatedData.othersRate);

    // Bulk total
    updatedData.bulkTotal =
      (safeNumber(updatedData.unloadingKhamali) +
        safeNumber(updatedData.containerCount)) *
      safeNumber(updatedData.bulkRate);

    // Bag total
    updatedData.bagTotal =
      safeNumber(updatedData.Bags) * safeNumber(updatedData.bagRate);

    setFormData(updatedData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://irc.zentelex.com/api/labour/labourentry",
        {
          entry_type: "OUTBOUND",

          clientName: formData.Client,
          cddNo: deliveryorder.cddNo,
          product: formData.Product,
          cargo_type: formData.cargoType,

          /* LABOURS */
          restacking_labours: Number(formData.Restacking),
          stitching_labours: Number(formData.Stitching),
          sweeping_labours: Number(formData.sweeping),
          others: Number(formData.Others),

          /* RATES */
          restacking_rate: Number(formData.restackingRate),
          stitching_rate: Number(formData.stitchingRate),
          sweeping_rate: Number(formData.sweepingRate),
          other_rate: Number(formData.othersRate),

          /* TOTALS */
          restacking_total: formData.restackingTotal,
          stitching_total: formData.stitchingTotal,
          sweeping_total: formData.sweepingTotal,
          other_total: formData.othersTotal,

          /* BULK */
          bulk_labours_loading: Number(formData.bulk_loading),
          bulk_labours_unloading: 0,
          bulk_containers: Number(formData.containerCount),
          bulk_rate: Number(formData.bulkRate),
          bulk_total: formData.bulkTotal,

          /* BAGS */
          bag_quantity_range: formData.bagRange || null,
          bag_rate: Number(formData.bagRate),
          bag_total: formData.bagTotal,
          bags: Number(formData.Bags),

          /* META */
          quantity: Number(formData.Quantity),
          entryDate: formData.Date,
          entryTime: formData.Time,
          warehouse: formData.warehouse,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("Data Submitted Successfully!", {
        position: "top-right",
        autoClose: 1500,
        theme: "colored",
      });

      setTimeout(() => {
        navigate("/accounts/billing");
      }, 2000);

      sessionStorage.removeItem("orderprocess");
    } catch (error) {
      console.error("Labour Entry Error:", error);

      toast.error(error.response?.data?.message || "Failed to submit data", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  return (
    <>
      <div className="content-page">
        <div className="card mb-4">
          <div className="card-header fw-semibold">Select Delivery Order</div>

          <div
            className="table-responsive"
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            <table className="table table-hover table-bordered mb-0">
              <thead className="table-light sticky-top">
                <tr>
                  <th></th>
                  <th>DO No</th>
                  <th>Client</th>
                  <th>Product</th>
                  <th>Cargo Type</th>
                  <th>Warehouse</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {doList.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Delivery Orders Found
                    </td>
                  </tr>
                )}

                {doList.map((doItem) => (
                  <tr key={doItem.id}>
                    <td></td>
                    <td>{doItem.doNo}</td>
                    <td>{doItem.clientName}</td>
                    <td>{doItem.product}</td>
                    <td>{doItem.cargo_type}</td>
                    <td>{doItem.warehouse}</td>
                    <td>
                      {" "}
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleDoSelect(doItem)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title">Labour for loading</h4>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mt-4">
              <div className="col-xxl-6 col-lg-8 col-md-10">
                <div className="card shadow-sm border-0 rounded-3">
                  <div
                    className="card-body p-4"
                    style={{ backgroundColor: "#3075A6" }}
                  >
                    <h4
                      className="card-title mb-4 text-center fw-semibold"
                      style={{ color: "white" }}
                    >
                      Outbound Assign Labours for loading
                    </h4>

                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Client:
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="Client"
                          value={formData.Client}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="row">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "white" }}
                        >
                          Assign Labours-
                        </label>

                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-semibold text-white">
                            Restacking
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="Restacking"
                            placeholder="No. of labours"
                            value={formData.Restacking}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            id="restackingRate"
                            placeholder="Rate"
                            value={formData.restackingRate}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            value={formData.restackingTotal}
                            readOnly
                            placeholder="Total"
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-semibold text-white">
                            Stitching
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="Stitching"
                            placeholder="No. of labours"
                            value={formData.Stitching}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            id="stitchingRate"
                            placeholder="Rate"
                            value={formData.stitchingRate}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            value={formData.stitchingTotal}
                            readOnly
                            placeholder="Total"
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-semibold text-white">
                            Sweeping
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="sweeping"
                            placeholder="No. of labours"
                            value={formData.sweeping}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            id="sweepingRate"
                            placeholder="Rate"
                            value={formData.sweepingRate}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            value={formData.sweepingTotal}
                            readOnly
                            placeholder="Total"
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-semibold text-white">
                            Others
                          </label>

                          <input
                            type="number"
                            className="form-control"
                            id="Others"
                            placeholder="No. of labours"
                            value={formData.Others}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            id="othersRate"
                            placeholder="Rate"
                            value={formData.othersRate}
                            onChange={handleChange}
                          />

                          <input
                            type="number"
                            className="form-control mt-2"
                            value={formData.othersTotal}
                            readOnly
                            placeholder="Total"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Product / Commodity Name:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Product"
                            value={formData.Product}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label fw-semibold"
                              style={{ color: "white" }}
                            >
                              Cargo Type:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="cargoType"
                              name="cargoType"
                              placeholder="Enter Cargo Type"
                              value={formData.cargoType}
                              onChange={handleChange}
                              readOnly
                            />
                          </div>

                          {formData.cargoType === "Bag_50" && (
                            <div className="row mt-3">
                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Bag Quantity Range
                                </label>
                                <select
                                  className="form-select"
                                  id="bagRange"
                                  value={formData.bagRange}
                                  onChange={handleChange}
                                >
                                  <option value="">Select Bag Range</option>
                                  <option value="UPTO_400">
                                    Up to 400 Bags
                                  </option>
                                  <option value="401_500">
                                    401 to 500 Bags
                                  </option>
                                  <option value="500_ABOVE">500 & Above</option>
                                </select>
                              </div>

                              <div className="col-md-3 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Rate
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="bagRate"
                                  placeholder="Rate per bag"
                                  value={formData.bagRate}
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-md-3 mb-3">
                                <label
                                  className="form-label fw-semibold"
                                  style={{ color: "white" }}
                                >
                                  No of Bags:
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="Bags"
                                  value={formData.Bags}
                                  onChange={handleChange}
                                />
                              </div>

                              <div className="col-md-3 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Total
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={formData.bagTotal}
                                  readOnly
                                  placeholder="Total"
                                />
                              </div>
                            </div>
                          )}

                          {formData.cargoType === "Bag_30/25" && (
                            <div className="row mt-3">
                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Bag Quantity Range
                                </label>

                                <select
                                  className="form-select"
                                  id="bagRange"
                                  value={formData.bagRange}
                                  onChange={handleChange}
                                >
                                  <option value="">Select Bag Range</option>
                                  <option value="UPTO_400">
                                    Up to 400 Bags
                                  </option>
                                  <option value="401_500">
                                    401 to 500 Bags
                                  </option>
                                  <option value="500_ABOVE">500 & Above</option>
                                </select>
                              </div>
                              <div className="col-md-3 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Rate
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="bagRate"
                                  placeholder="Rate per bag"
                                  value={formData.bagRate}
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="col-md-3 mb-3">
                                <label
                                  className="form-label fw-semibold"
                                  style={{ color: "white" }}
                                >
                                  No of Bags:
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="Bags"
                                  value={formData.Bags}
                                  onChange={handleChange}
                                />
                              </div>

                              <div className="col-md-3 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Total
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={formData.bagTotal}
                                  readOnly
                                  placeholder="Total"
                                />
                              </div>
                            </div>
                          )}
                          {formData.cargoType === "Bulk" && (
                            <div className="row mt-4">
                              <h6 className="fw-semibold text-white mb-3">
                                Bulk loading Details
                              </h6>

                              <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  loading Khamali
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="bulk_loading"
                                  placeholder="No. of labours"
                                  value={formData.bulk_loading}
                                  onChange={handleChange}
                                />
                              </div>

                              <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Containers
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="containerCount"
                                  placeholder="No. of containers"
                                  value={formData.containerCount}
                                  onChange={handleChange}
                                />
                              </div>

                              <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold text-white">
                                  Rate
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="bulkRate"
                                  placeholder="Rate per unit"
                                  value={formData.bulkRate}
                                  onChange={handleChange}
                                />
                              </div>

                              <div className="col-md-6 mt-2">
                                <label className="form-label fw-semibold text-white">
                                  Total Amount
                                </label>
                                <input
                                  type="number"
                                  className="form-control fw-semibold"
                                  value={formData.bulkTotal}
                                  readOnly
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Quantity:
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="Quantity"
                            value={formData.Quantity}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Date:
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="Date"
                            value={formData.Date}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Time:
                          </label>
                          <input
                            type="time"
                            className="form-control"
                            id="Time"
                            value={formData.Time}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{ color: "white" }}
                          >
                            Warehouse:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="warehouse"
                            value={formData.warehouse}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn px-5 py-2 fw-semibold"
                          style={{
                            backgroundColor: "#EC662C",
                            color: "white",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <ToastContainer />
          </div>
        </div>
      </div>
    </>
  );
};

export default LabourOutbound;

